import { UseQueryResult } from "react-query";
import { useGetUserInfo } from "features/users/hooks/useGetUserInfo";

export default function useGetBalance(): UseQueryResult<string> {
    return useGetUserInfo({ select: (data) => data?.wallet?.balance || "0" });
}
